import { Directive, ElementRef, Input, OnChanges, OnInit } from '@angular/core';

@Directive({
  selector: '[appGridColumns]'
})
export class GridColumnsDirective implements OnInit, OnChanges {
  /** shorthand: aplica a desktop si no se pasan los específicos */
  @Input() colWidths?: number[] | null;

  /** por breakpoint (arrays de porcentajes sin %): */
  @Input() colWidthsLg?: number[] | null;
  @Input() colWidthsMd?: number[] | null;
  @Input() colWidthsSm?: number[] | null;

  /** fallback a columnas fraccionales si no hay porcentajes */
  @Input() colsLg = 3;
  @Input() colsMd = 2;
  @Input() colsSm = 1;

  private host: HTMLElement;

  constructor(private el: ElementRef<HTMLElement>) {
    this.host = this.el.nativeElement;
    // estilos base (no tocar grid-template-columns aquí)
    this.host.style.display = 'grid';
    this.host.style.gap = '16px';
    this.host.style.width = '100%';
    this.host.style.boxSizing = 'border-box';
  }

  ngOnInit(): void {
    this.applyGridConfig();
  }

  ngOnChanges(): void {
    this.applyGridConfig();
  }

  private applyGridConfig() {
    // 1) Fallback: escribir las variables numéricas para repeat(...)
    this.host.style.setProperty('--cols-lg', String(this.colsLg));
    this.host.style.setProperty('--cols-md', String(this.colsMd));
    this.host.style.setProperty('--cols-sm', String(this.colsSm));

    // 2) Si se pasan porcentajes, crear variables específicas para cada breakpoint
    // Preferencia: colWidthsLg/md/sm > colWidths (shorthand)
    this.setPercentVar('--cols-lg-custom', this.colWidthsLg ?? this.colWidths ?? null);
    this.setPercentVar('--cols-md-custom', this.colWidthsMd ?? null);
    this.setPercentVar('--cols-sm-custom', this.colWidthsSm ?? null);
  }

  private setPercentVar(varName: string, arr: number[] | null | undefined) {
    if (!arr || arr.length === 0) {
      // eliminar la variable si no hay valor para que el CSS use el fallback
      this.host.style.removeProperty(varName);
      return;
    }
    // convertir [35,30,35] -> "minmax(0, 35fr) minmax(0, 30fr) minmax(0, 35fr)"
    // usando fr evitamos desbordamientos cuando hay gap entre columnas
    const value = arr.map(n => `minmax(0, ${n}fr)`).join(' ');
    this.host.style.setProperty(varName, value);
  }
}
